import { MaskedLines, Reveal, Overline } from "./shared";
import { LightArt } from "./LightArt";

const PIECES = [
    { name: "Reception Sculpture", variant: "rings", hue: "warm" },
    { name: "Hanging Kinetic Light", variant: "rods", hue: "warm" },
    { name: "Moving Wall Artwork", variant: "grid", hue: "mixed" },
    { name: "Small Interactive Piece", variant: "burst", hue: "cool" },
    { name: "Restaurant Feature", variant: "halo", hue: "warm" },
    { name: "Hotel Lobby Sculpture", variant: "wave", hue: "cool" },
    { name: "Corporate Reception Art", variant: "grid", hue: "warm" },
    { name: "Luxury Home Installation", variant: "rings", hue: "cool" },
];

export const SmallScale = () => (
    <section data-testid="small-scale-section" className="relative border-t border-white/5 py-32 md:py-48">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12">
            <Overline>Small or Extraordinary</Overline>
            <h2 className="mt-10 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
                <MaskedLines lines={["You don't need", "a huge space."]} />
            </h2>
            <Reveal className="mt-10 max-w-xl">
                <p className="text-lg font-light leading-relaxed text-white/60 md:text-xl">
                    Sometimes one moving object is enough to transform a room.
                </p>
            </Reveal>
            <div className="mt-20 grid grid-cols-2 gap-px bg-white/10 lg:grid-cols-4">
                {PIECES.map((p, i) => (
                    <Reveal key={p.name} delay={(i % 4) * 0.08} className="group relative aspect-square bg-[#070708]">
                        <LightArt variant={p.variant} hue={p.hue} className="h-full w-full opacity-70 transition-opacity duration-700 group-hover:opacity-100" />
                        <span className="absolute bottom-4 left-4 right-4 font-mono-tech text-[9px] uppercase tracking-[0.25em] text-white/50 transition-colors duration-500 group-hover:text-white/90 md:text-[10px]">
                            {p.name}
                        </span>
                    </Reveal>
                ))}
            </div>
            <div className="mt-24 md:mt-32">
                <h3 className="font-display text-2xl font-bold uppercase leading-tight tracking-tight text-white/85 sm:text-3xl lg:text-5xl">
                    <MaskedLines lines={["From one statement piece", "to an entire moving environment."]} />
                </h3>
            </div>
        </div>
    </section>
);
